require('./brokerStocksContractStep1.scss');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');

// @ commons
const { HTMLSafeInjector } = require('commonsComponents/htmlSafeInjector');

// @ constants
const { OPEN_SECURITIES_LOCATION } = require('constants/index');

const nonCollectivoContentParams = [
    {
        row : [
            {
                iconClass : 'icon-acciones-internacionales',
                title : 'broker-stocksContractStep1AdvantageTitle1',
                paragraph : 'broker-stocksContractStep1AdvantageParagraph1'
            },
            {
                iconClass : 'icon-tiempo',
                title : 'broker-stocksContractStep1AdvantageTitle2',
                paragraph : 'broker-stocksContractStep1AdvantageParagraph2'
            }
        ]
    },
    {
        row : [
            {
                iconClass : 'icon-documento',
                title : 'broker-stocksContractStep1AdvantageTitle3',
                paragraph : 'broker-stocksContractStep1AdvantageParagraph3'
            },
            {
                iconClass : 'icon-movil',
                title : 'broker-stocksContractStep1AdvantageTitle4',
                paragraph : 'broker-stocksContractStep1AdvantageParagraph4'
            }
        ]
    }];

class BrokerStocksContractStep1 extends React.Component {

    componentDidMount() {
        const {
            getContractInformationWithPricing,
            history,
            immStocksContractForm,
            isCollective
        } = this.props;

        if (!immStocksContractForm.get('informationStep1') && isCollective) {
            getContractInformationWithPricing(OPEN_SECURITIES_LOCATION, history);
        }
    }

    componentDidUpdate(prevProps) {
        const { immStocksContractForm, getContractInformationWithPricing, history, isCollective } = this.props;
        if (prevProps.isCollective !== isCollective) {
            if (!immStocksContractForm.get('informationStep1') && isCollective) {
                getContractInformationWithPricing(OPEN_SECURITIES_LOCATION, history);
            }
        }
    }

    buildRowContent(rowParams) {
        return rowParams.map((columnData, key) => {
            const iconClass = classNames('stocks-contract-step1__advantage-icon', columnData.iconClass);

            return (
                <div className="stocks-contract-step1__advantage col-xs-6" key={key}>
                    <div className={iconClass}>&nbsp;</div>
                    <div className="stocks-contract-step1__advantage-title">{formatText(columnData.title)}</div>
                    <div className="stocks-contract-step1__advantage-separator">&nbsp;</div>
                    <div className="stocks-contract-step1__advantage-paragraph">{formatText(columnData.paragraph)}</div>
                </div>
             );
        });
    }

    buildContent() {
        const rowContent = nonCollectivoContentParams.map((params, key) => {
            return (
                <div className="row" key={key}>
                    {this.buildRowContent(params.row)}
                </div>
            );
        });
        return rowContent;
    }

    getContent() {
        const stepContent = this.buildContent();

        return (
            <div className="stocks-contract-step1">
                <div className="stocks-contract-step1__title">
                    <FormattedText value="broker-stocksContractSideTitle" format="uppercase" />
                </div>
                <div className="stocks-contract-step1__subtitle">{formatText('broker-stocksContractStep1SubTitle')}</div>
                <div className="container-fluid">
                    {stepContent}
                </div>
            </div>
        );
    }

    render() {
        const { immStocksContractForm, isCollective } = this.props;
        const information = immStocksContractForm.get('informationStep1');
        let content;

        if (immStocksContractForm.get('isFetchingStep1')) {
            content = <LoadingSection />;
        }

        if (!immStocksContractForm.get('informationStep1') && isCollective) {
            const emptyStateTitle = formatText('broker-emptyStateTitle');
            const emptyStateText =  formatText('broker-emptyStateText');

            content = <EmptyState title={emptyStateTitle} primaryText={emptyStateText} />;
        } else {
            content = isCollective ? <HTMLSafeInjector message={information} /> : this.getContent();  // Content for non-collectivo user
        }

        return (
            <article className="contract-information">
                {content}
            </article>
        );
    }
}

BrokerStocksContractStep1.propTypes = {
    history: PropTypes.object.isRequired,
    immStocksContractForm: PropTypes.object.isRequired,
    getContractInformationWithPricing: PropTypes.func.isRequired,
    isCollective: PropTypes.bool
};

BrokerStocksContractStep1.defaultProps = {
    isCollective: false
};

module.exports = withRouter(BrokerStocksContractStep1);
